import React from 'react';
import cn from 'classnames';

import { ReactComponent as CheckedIcon } from 'assets/imgs/checkbox-checked.svg';
import classes from './checkbox.module.scss';
import { ICheckbox } from './types';

const Checkbox: React.FC<ICheckbox> = ({ 
	className,
	value,
	onChange,
	label,
	disabled,
}) => {

	const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if (disabled) return;

		onChange(!value);
	};

	return (
		<div
			className={cn(classes.checkbox, className, { [classes.checkbox__disabled]: disabled })}
			onClick={handleClick}
		>
			<div className={cn(classes.box, { [classes.box__checked]: value })}>
				{value && <CheckedIcon className={classes.checkedIcon} />}
			</div>
			{label && <div className={classes.label}>{label}</div>}
		</div>
	);
};

export default Checkbox;
